import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Fallback to emoji if image fails to load
const LogoComponent = () => {
  const [imageError, setImageError] = useState(false);
  
  if (imageError) {
    return <span style={{ fontSize: '1.5rem' }}>🧠</span>;
  }
  
  return (
    <img 
      src="/images/Logo.png" 
      alt="MindXchange Logo" 
      className="logo-image" 
      onError={() => setImageError(true)}
    />
  );
};

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="global-header">
      <div className="nav-container">
        <Link to="/" className="logo" onClick={closeMobileMenu}>
          <LogoComponent />
        </Link>
        <nav>
          <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <li><Link to="/services" onClick={closeMobileMenu}>Services</Link></li>
            <li><Link to="/about" onClick={closeMobileMenu}>About Us</Link></li>
            <li><Link to="/faq" onClick={closeMobileMenu}>FAQ</Link></li>
          </ul>
        </nav>
        <Link to="/contact" className="contact-btn" onClick={closeMobileMenu}>CONTACT</Link>
        <button 
          className="mobile-menu-toggle" 
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
          aria-expanded={isMobileMenuOpen}
        >
          {isMobileMenuOpen ? '✕' : '☰'}
        </button>
      </div>
    </header>
  );
};

export default Header; 